import { handleActions } from 'redux-actions';
import { setTravellers } from './actions';
const initialState = {};
const travellersReducer = handleActions({
    [setTravellers.toString()]: (_, { payload }) => payload
}, initialState);
export default travellersReducer;
